import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import CustomSelect from "../CustomSelect/CustomSelect";
import Tooltip from "../Tooltip/Tooltip";
import SelectSearch from "react-select-search";
import "react-select-search/style.css";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
function SelectFormField({
  testId,
  label,
  ariaLabel,
  options,
  dropdownChange,
  control,
  loading,
  fieldName,
  errorMessage,
  labelClassNames,
  selectClassNames,
  isChild,
  tooltip,
  rules,
  currentValue,
  classLabel,
  classQuestion,
  isSearchable,
  placeholder,
  mainDivClass,
  defaultOption,
  standardQuestionName,
  isMultiSelect,
  multiSelectOnChange,
  register,
  setValue,
  trigger,
  QuestionInterface,
  values,
  formName,
  isCustomMenuButton = false,
  customMenuButtonAction,
  isOptionEditable = false,
  customOptionEditAction,
  labelCustomStyle,
  handleMenuOpen,
  tinySelect,
  key,
  handleInputChange,
  isLoading,
  loadOptions,
  isAsync,
  isLimitSearchResult,
  isLenderDropdown,
  islawyerFilterApplied,
  setislawyerFilterApplied,
  isOrderStatus,
  isProvinceField,
}) {
  const { t } = useTranslation();
  console.log("🚀 ~ SelectFormField ~ islawyerFilterApplied:", islawyerFilterApplied)

  useEffect(() => {

  }, [islawyerFilterApplied])

  return (
    <>
      <div
        className={
          mainDivClass
            ? mainDivClass
            : isChild === undefined
              ? label !== undefined
                ? "inline-flex  space-x-4 py-6"
                : "py-0"
              : !isChild
                ? "inline-flex  space-x-4"
                : "mb-4" + (classLabel ? ` ${classLabel}` : "")
        }
      >
        {label != null ? (
          <div className={labelClassNames} style={labelCustomStyle}>
            {tooltip ? (
              <span>
                {parse(label)} <Tooltip text={tooltip} />
              </span>
            ) : (
              label
            )}
          </div>
        ) : (
          ""
        )}

        <div
          className={
            (!isChild
              ? "flex flex-row items-center"
              : "flex flex-row items-center" +
              (classQuestion ? ` ${classQuestion}` : ""))
            + ` select-container ${islawyerFilterApplied ? 'filter-applied' : ''}`
          }
          aria-label={ariaLabel}
          role="application"
        >
          <div className={selectClassNames}>
            <Controller
              control={control}
              name={fieldName}
              rules={rules || {}}
              render={
                ({ field: { onBlur, value, name, ref } }) => (
                  // isSearchable ? (
                  <CustomSelect
                    defaultValue={defaultOption ? defaultOption : t("select")}
                    onBlur={onBlur}
                    onChange={
                      dropdownChange
                    }
                    inputRef={ref}
                    name={name}
                    options={options}
                    value={value}
                    setValue={setValue}
                    currentValue={currentValue || null}
                    isDisabled={loading}
                    placeholder={placeholder}
                    testId={testId}
                    isSearchable={isSearchable}
                    standardQuestionName={standardQuestionName}
                    isMultiSelect={isMultiSelect}
                    multiSelectOnChange={multiSelectOnChange}
                    values={values}
                    formName={formName}
                    isCustomMenuButton={isCustomMenuButton}
                    customMenuButtonAction={customMenuButtonAction}
                    t={t}
                    isOptionEditable={isOptionEditable}
                    customOptionEditAction={customOptionEditAction}
                    handleMenuOpen={handleMenuOpen}
                    tinySelect={tinySelect}
                    key={isProvinceField ? `key-${values}-${Date.now()}` : key}
                    handleInputChange={handleInputChange}
                    isLoading={isLoading}
                    loadOptions={loadOptions}
                    isAsync={isAsync}
                    isLimitSearchResult={isLimitSearchResult}
                    isLenderDropdown={isLenderDropdown}
                    islawyerFilterApplied={islawyerFilterApplied}
                    setislawyerFilterApplied={setislawyerFilterApplied}
                    isOrderStatus={isOrderStatus}
                    trigger={trigger}
                  />
                )
                // ) : (
                //   <>
                //     =
                //     <SelectSearch
                //       inputRef={ref}
                //       options={options}
                //       value={currentValue || placeholder || ''}
                //       name={name}
                //       placeholder={placeholder || 'Select...'}
                //       search
                //       onBlur={onBlur}
                //       onChange={(val) => {
                //         dropdownChange(val, name);
                //       }}
                //       renderOption={(
                //         optionsProps,
                //         optionData,
                //         optionSnapshot,
                //         className
                //       ) => (
                //         <>
                //           <option
                //             {...optionsProps}
                //             htmlFor={optionData.value}
                //             className={className}
                //             style={{
                //               backgroundColor:
                //                 optionSnapshot?.selected ||
                //                 optionSnapshot?.highlighted
                //                   ? '#fffaeb'
                //                   : 'transparent',
                //             }}
                //           >
                //             {optionData.name}
                //           </option>
                //         </>
                //       )}
                //       renderValue={(valueProps, _, className) => (
                //         <input
                //           className={className}
                //           data-cy={testId}
                //           {...valueProps}
                //           placeholder={placeholder || 'Search...'}
                //         />
                //       )}
                //     />
                //   </>
                // )
              }
            />
            {QuestionInterface &&
              QuestionInterface === "multiselectcheckboxdropdown" && (
                <div className="flex flex-row">
                  <div className="flex items-center my-4">
                    <input
                      id="CheckTermsLoanRequired_sn-checkbox"
                      type="checkbox"
                      name="CheckTermsLoanRequired_sn"
                      data-cy={`${fieldName}.CheckTermsLoanRequired`}
                      className="w-4 h-4 custom__checkbox custom__checkbox-multiple pl-2 relative"
                      {...register(`${fieldName}.CheckTermsLoanRequired`)}
                      checked={currentValue?.CheckTermsLoanRequired || false}
                      onChange={(e) => {
                        e.persist();
                        setValue(
                          `${fieldName}.CheckTermsLoanRequired`,
                          e.target.checked
                        );
                        trigger(`${fieldName}.CheckTermsLoanRequired`);
                      }}
                    />
                    <label
                      htmlFor="CheckTermsLoanRequired_sn-checkbox"
                      className="ml-2 font-normal"
                    >
                      {t("none")}
                    </label>
                  </div>
                </div>
              )}
            <span
              className="custom__dropdown-wrapper top-[10px] font-semibold text-secondary-red"
              style={{ display: "block", width: 230 }}
            >
              {errorMessage}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(SelectFormField);
